import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useLang } from "@/lib/lang";
import { Menu, X, Globe, Phone } from "lucide-react";
import { LogoLockup } from "@/components/dw/Logo";
import { PHONE } from "@/lib/constants";

const links = [
  { key: "about", href: "#about" },
  { key: "how", href: "#how" },
  { key: "plans", href: "#plans" },
  { key: "stories", href: "#stories" },
  { key: "blog", href: "#blog" },
  { key: "contact", href: "#contact" },
];

export default function Nav() {
  const { lang, t, setLang } = useLang();
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const onLanding = pathname === "/";
  return (
    <header
      data-testid="site-nav"
      className="sticky top-0 z-50 border-b"
      style={{ backdropFilter: "blur(16px)", WebkitBackdropFilter: "blur(16px)", background: "rgba(255, 253, 245, 0.85)", borderColor: "var(--border-subtle)" }}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 flex items-center justify-between h-16 md:h-20">
        <Link to="/" data-testid="nav-brand" className="flex-shrink-0">
          <LogoLockup size={54} />
        </Link>

        {onLanding && (
          <nav className="hidden lg:flex items-center gap-7 text-[13.5px] font-semibold" style={{ color: "var(--text-secondary)" }}>
            {links.map((l) => (
              <a key={l.key} href={l.href} data-testid={`nav-${l.key}`} className="hover:text-[var(--primary)] transition-colors">
                {t.nav[l.key]}
              </a>
            ))}
            <Link to="/recipes" data-testid="nav-recipes" className="hover:text-[var(--primary)] transition-colors">
              Recipes
            </Link>
          </nav>
        )}

        <div className="flex items-center gap-2 md:gap-3">
          <button
            data-testid="lang-toggle"
            onClick={() => setLang(lang === "en" ? "hi" : "en")}
            className="hidden sm:inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-bold border-2 hover:scale-[1.02] transition-transform"
            style={{ borderColor: "var(--primary)", color: "var(--primary)", background: "transparent" }}
          >
            <Globe size={13} /> {lang === "en" ? "हिंदी" : "EN"}
          </button>
          <a
            data-testid="nav-call"
            href={`tel:${PHONE}`}
            className="hidden md:inline-flex items-center gap-2 px-4 py-2 rounded-full text-xs font-bold transition-all hover:scale-[1.03]"
            style={{ background: "var(--primary)", color: "var(--yellow)" }}
          >
            <Phone size={12} /> +1 437-557-1041
          </a>
          {onLanding && (
            <button data-testid="mobile-menu-btn" className="lg:hidden p-2" onClick={() => setOpen((o) => !o)} aria-label="Menu">
              {open ? <X /> : <Menu />}
            </button>
          )}
        </div>
      </div>

      {onLanding && open && (
        <div className="lg:hidden border-t" style={{ borderColor: "var(--border-subtle)", background: "var(--bg)" }}>
          <div className="px-5 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <a key={l.key} href={l.href} data-testid={`mnav-${l.key}`} className="py-2 font-semibold" onClick={() => setOpen(false)}>
                {t.nav[l.key]}
              </a>
            ))}
            <Link to="/recipes" data-testid="mnav-recipes" className="py-2 font-semibold" onClick={() => setOpen(false)}>
              Recipes
            </Link>
            <a href="#contact" data-testid="mnav-book" className="btn-primary mt-2" onClick={() => setOpen(false)}>{t.nav.book}</a>
          </div>
        </div>
      )}
    </header>
  );
}
